/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PolicyViolationRow = zod
	.object({
		affected_persons: zod.number().describe('Distinct affected actors'),
		last_violation_at: zod.iso.date().describe('Most recent violation date'),
		policy_plan_id: zod.string().describe('Policy plan ID'),
		violations: zod.number().describe('Violation count')
	})
	.describe('Policy violation breakdown row');

export type PolicyViolationRow = zod.input<typeof PolicyViolationRow>;
export type PolicyViolationRowOutput = zod.output<typeof PolicyViolationRow>;
